import { Component, computed, inject } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive, Router, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth.service';
import { filter, map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, RouterLink, RouterLinkActive],
    templateUrl: './app.html',
    styleUrl: './app.css',
})
export class App {
    protected authService = inject(AuthService);
    private router = inject(Router);

    protected user = this.authService.user;
    protected userInitial = computed(() => {
        const u = this.user();
        if (u?.name) return u.name.charAt(0).toUpperCase();
        if (u?.email) return u.email.charAt(0).toUpperCase();
        return 'U';
    });

    protected isProjectsRoute = toSignal(
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.router.url.startsWith('/projects')),
        ),
        { initialValue: this.router.url.startsWith('/projects') },
    );

    onLogout() {
        this.authService.logout();
    }
}
